// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__KCbbq","errorLogs":"EditorFooter_errorLogs__ZBdYr"};